<h1 mat-dialog-title>{{ 'scheduler.setup.team-list.title.single' | translate }} Add</h1>

<!--<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>-->
<!--<mat-card *ngIf="isError">-->
<!--<mat-card-header>-->
<!--{{errorMessage| translate}}-->
<!--</mat-card-header>-->
<!--<mat-card-actions>-->
<!--<button mat-button (click)="retryLoad()">{{ 'scheduler.general.retry' | translate }}</button>-->
<!--</mat-card-actions>-->
<!--</mat-card>-->

<form (ngSubmit)="addTeam()" [formGroup]="teamForm">

  <mat-icon color="accent">group</mat-icon>
  <mat-form-field>
    <input formControlName="teamNameFC" matInput required type="text">
    <mat-label>Name</mat-label>
    @if (teamForm.controls['teamNameFC']) {
      <mat-error>Please enter name !</mat-error>
    }
  </mat-form-field>

  <mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="onCancelClick()" mat-flat-button type="reset">{{ 'scheduler.general.cancel' | translate }}</button>
    <button [disabled]="!teamForm.valid" color="primary" mat-raised-button type="submit">Add</button>
  </mat-dialog-actions>
</form>